import React from "react";
import { Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import useIsLoggedIn from "app/hooks/useIsLoggedIn";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const ModalHeader: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const {
    state: {
      userAnswers,
      selectedPrompt,
      selectedQuestion,
      userInformationRequest
    } = {}
  } = usePostStoryContext();

  if (!isLoggedIn) return <h4 className="hidden">{userInformationRequest ? "Confirm Details" : "Answer Prompt"}</h4>;

  return (
    <>
      {selectedPrompt && !selectedQuestion && (
        <span className="User-Answers">
          {userAnswers !== 0 ? (
            <>
              <Icon icon="checkmark" />
              <Trans>You added {userAnswers} stor{userAnswers === 1 ? "y" : "ies"} to this prompt so far</Trans>
            </>
          ) : (
            <Trans>You have not added stories to this prompt so far</Trans>
          )}
        </span>
      )}
    </>
  );
};

export default ModalHeader;
